/**
 * 模块: KeywordTrendPivot Components
 * 职责: 关键词趋势透视表子组件（趋势图标、标签等）
 * 限制: <280行
 */

import React from 'react';
import { Tag } from 'antd';
import {
  ArrowUpOutlined,
  ArrowDownOutlined,
  MinusOutlined,
  RiseOutlined,
  FallOutlined,
} from '@ant-design/icons';

/**
 * 趋势图标组件
 */
export const TrendIcon: React.FC<{ trend: 'up' | 'down' | 'stable' }> = ({ trend }) => {
  if (trend === 'up') {
    return <ArrowUpOutlined style={{ color: '#52c41a' }} />;
  }
  if (trend === 'down') {
    return <ArrowDownOutlined style={{ color: '#ff4d4f' }} />;
  }
  return <MinusOutlined style={{ color: '#8c8c8c' }} />;
};

/**
 * 趋势标签组件
 */
export const TrendTag: React.FC<{ trend: 'up' | 'down' | 'stable'; label: string }> = ({
  trend,
  label,
}) => {
  const color = trend === 'up' ? 'green' : trend === 'down' ? 'red' : 'default';
  const icon = trend === 'up' ? <RiseOutlined /> : trend === 'down' ? <FallOutlined /> : null;

  return (
    <Tag color={color} icon={icon}>
      {label}
    </Tag>
  );
};

